
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("9LIHd", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $88f981dd017f7969$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Spanish (International)
var $52e04c15edb6c5a3$export$2e2bcd8739ae039 = {
    'confluence-analytics-byline.abbreviated-user-views.message': '{count, plural, =0 {Visualizaciones} one {{1}} other {{count}}}',
    'confluence-analytics-byline.page-viewers.message': 'Visores',
    'confluence-analytics-byline.user-views.message': "{count, plural, =0 {An\xe1lisis} one {Visto por 1\xa0persona} other {Visto por {count}\xa0personas}}"
};


var $88f981dd017f7969$export$2e2bcd8739ae039 = (0, $52e04c15edb6c5a3$export$2e2bcd8739ae039);

});


//# sourceMappingURL=es.4cc936a7.js.map
